export default __webpack_public_path__ + "static/media/sunrise.89a1b4c8.svg";